import React from "react";
import HelmetWrapper from "../../HelmetWrapper";
import { Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { selectAuth } from "../../components/auth/auth.selector";
import LeadClosure from "../../components/lead-closure-report/LeadClosure";
import "../../styles/open-pages/lead-closure-report.css";

const LeadClosureReport = () => {
  const authData = useSelector(selectAuth);
  const userInfoData = authData?.user || {};

  return (
    <HelmetWrapper title="WTF: Lead Closure Report">
      <Container className="bg-cloud-k px-50px" fluid>
        <LeadClosure userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default LeadClosureReport;
